import { takeLatest, put, take, call } from 'redux-saga/effects';
import Querystring from 'querystring';
import types from 'redux/types';
import StatsServices from 'services/StatsServices';
import { isResponseSuccess } from 'helpers';
import { handleWorker } from 'helpers/saga';
import components, { typeUnmounted } from 'consts/components';
import { showError } from 'helpers/handleError';

function* getStats() {
  try {
    const res = yield StatsServices.getStats(
      Querystring.stringify({
        deviceId: '',
        refresh: false,
        action: 'load',
      })
    );
    if (isResponseSuccess(res.status)) {
      yield put({
        type: types.REQUEST_GET_STATS_SUCCESS,
        stats: JSON.parse(res?.data?.stats || '{}') || {},
        history: res.data.history || [],
      });
    }
  } catch (error) {
    showError(error);
    yield put({
      type: types.REQUEST_GET_STATS_SUCCESS,
      error,
    });
  }
}

function* getMessageStats({ from, to, callbacks }) {
  try {
    const res = yield StatsServices.getMessageStats({ from, to });
    if (isResponseSuccess(res.status)) {
      callbacks && callbacks.onSuccess(res);
      yield put({
        type: types.REQUEST_MESSAGE_STATS_SUCCESS,
        data: res.data,
      });
    }
  } catch (error) {
    showError(error);
    callbacks && callbacks.onFailed(error);
    yield put({
      type: types.REQUEST_MESSAGE_STATS_FAILED,
      error,
    });
  }
}

function* getStatsByTime({ from, to, callbacks }) {
  try {
    const res = yield StatsServices.getStatsByTime({
      from,
      to,
    });
    if (isResponseSuccess(res.status)) {
      callbacks && callbacks.onSuccess(res);
      yield put({ type: types.REQUEST_STATS_BY_TIME_SUCCESS, data: res.data });
    }
  } catch (error) {
    showError(error);
    callbacks && callbacks.onFailed();
    yield put({
      type: types.REQUEST_STATS_BY_TIME_FAILED,
      error,
    });
  }
}

function* getHighlightHist({ from, to, callbacks }) {
  try {
    const res = yield StatsServices.getHistHighlight({
      from,
      to,
    });

    if (isResponseSuccess(res.status)) {
      if (typeof res.data !== 'string') {
        callbacks && callbacks.onSuccess(res);
        yield put({
          type: types.REQUEST_GET_HIGHLIGHT_HIST_SUCCESS,
          payload: res.data,
        });
      } else {
        showError('[HIGHLIGHT_HIST] ' + res.data);
        callbacks && callbacks.onFailed();
        yield put({
          type: types.REQUEST_GET_HIGHLIGHT_HIST_FAILED,
          error: res.data,
        });
      }
    }
  } catch (error) {
    showError(error);
    callbacks && callbacks.onFailed();
    yield put({
      type: types.REQUEST_GET_HIGHLIGHT_HIST_FAILED,
      error,
    });
  }
}

function* getCampaignStats(data) {
  const { callbacks, type, ...filters } = data;
  try {
    const res = yield call(StatsServices.getCampaignStats, filters);
    if (isResponseSuccess(res.status)) {
      yield put({
        type: types.REQUEST_GET_CAMPAIGN_STATS_SUCCESS,
      });
      callbacks && callbacks.onSuccess(res);
    }
  } catch (error) {
    showError(error);
    callbacks && callbacks.onFailed();
    yield put({
      type: types.REQUEST_GET_CAMPAIGN_STATS_FAILED,
      error,
    });
  }
}

export default function* () {
  yield takeLatest(types.REQUEST_GET_STATS, getStats);
  yield takeLatest(
    types.REQUEST_STATS_BY_TIME,
    handleWorker({
      handler: getStatsByTime,
      cancelled: take([typeUnmounted(components.homepage), typeUnmounted(components.statistics)]),
    })
  );
  yield takeLatest(
    types.REQUEST_MESSAGE_STATS,
    handleWorker({
      handler: getMessageStats,
      cancelled: take([typeUnmounted(components.homepage), typeUnmounted(components.statistics)]),
    })
  );
  yield takeLatest(types.REQUEST_GET_HIGHLIGHT_HIST, getHighlightHist);
  yield takeLatest(types.REQUEST_GET_CAMPAIGN_STATS, getCampaignStats);
}
